<template>
  <div>
    <v-card class="pl-3 pr-3" style="height: 62px" outlined shaped tile>
      <v-row>
        <v-col md="3">
          <form autocomplete="off">
            <v-menu transition="slide-y-transition" right offset-y :nudge-top="25">
              <template v-slot:activator="{ on }">
                <v-btn style="position: absolute" class="fs-btn-icons-topbar" v-on="on" icon>
                  <v-icon>mdi-help</v-icon>
                </v-btn>
              </template>
              <v-list class="fs-menu-pedidos">
                <v-list-item @click="dialogAjuda = true" class="fs-item-menu-pedidos">
                  <v-icon class="mr-3">mdi-grid</v-icon>Legendas do Grid
                </v-list-item>
              </v-list>
            </v-menu>
            <v-text-field
              @keydown.enter="filtros = {}; pesquisar()"
              class="fs-searchfield ml-12"
              label="Pesquisar"
              placeholder=" "
              spellcheck="false"
              v-model="textoPesquisa"
              append-icon="mdi-magnify"
              @click:append="filtros = {}; pesquisar()"
              outlined
              dense
            />
          </form>
        </v-col>
        <v-col md="2">
          <v-menu
            v-model="menuDataInicial"
            :close-on-content-click="false"
            :nudge-top="48"
            :nudge-right="10"
            transition="scale-transition"
            max-width="290"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formatDataInicial"
                append-outer-icon="mdi-calendar"
                label="Data Inicial"
                placeholder=" "
                @click:clear="dataInicial = null"
                v-on="on"
                outlined
                readonly
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataInicial" @change="menuDataInicial = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="2">
          <v-menu
            v-model="menuDataFinal"
            :close-on-content-click="false"
            :nudge-top="48"
            :nudge-right="10"
            transition="scale-transition"
            max-width="290"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formatDataFinal"
                append-outer-icon="mdi-calendar"
                label="Data Final"
                placeholder=" "
                @click:clear="dataFinal = null"
                v-on="on"
                outlined
                readonly
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataFinal" @change="menuDataFinal = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-switch
                v-model="filtroData"
                label="Filtro por Data"
                v-on="on"
                class="mt-0 pr-2"
                color="#2A2F50"
                :value="true"
                hide-details
              ></v-switch>
            </template>
            <span
              style="font-size: 11px"
            >{{ filtroData ? 'FILTRO POR DATA ATIVADO' : 'FILTRO POR DATA DESATIVADO' }}</span>
          </v-tooltip>
        </v-col>
        <v-col style="text-align: right; margin-right: -13px">
          <!-- <v-btn class="fs-btn-icons-topbar ml-3" icon>
            <v-icon>mdi-printer</v-icon>
          </v-btn>-->
          <!-- {{ filtroComposto }} -->
          <v-btn
            class="fs-btn-icons-topbar ml-3"
            :loading="excelLoader"
            @click="exportarExcel()"
            icon
          >
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
          <v-btn
            v-if="filtroComposto.length < 2"
            class="fs-btn-icons-topbar ml-3 mr-1"
            @click.stop="abrirDrawer()"
            icon
          >
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <v-menu
            v-if="filtroStatus && filtroComposto.length > 1"
            transition="slide-y-transition"
            left
            offset-y
            :nudge-top="25"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="fs-btn-filtro-ativo ml-3" v-on="on" icon>
                <v-icon style="color: white">mdi-filter</v-icon>
              </v-btn>
            </template>
            <v-list class="fs-menu-pedidos">
              <v-list-item @click="abrirDrawer()" class="fs-item-menu-pedidos">
                <v-icon class="mr-3">mdi-filter-outline</v-icon>Selecionar Filtros
              </v-list-item>
              <v-list-item @click="limparFiltrosGrid()" class="fs-item-menu-pedidos">
                <v-icon class="mr-3">mdi-delete-variant</v-icon>Limpar Filtros do Grid
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col md="1">
          <v-menu transition="slide-y-transition" left offset-y :nudge-top="25">
            <template v-slot:activator="{ on }">
              <v-btn
                :class="!$store.state.pedidos.pedidosSelecionados.length > 0 ? 'fs-btn-disabled' : 'fs-btn-enabled fs-boxshadow'"
                v-on="on"
                style="font-size: 11px"
                :disabled="!$store.state.pedidos.pedidosSelecionados.length > 0"
                outlined
                rounded
                block
              >Opções</v-btn>
            </template>
            <v-list class="fs-menu-pedidos">
              <v-list-item
                @click="dialog = true; componente = 'selecionarvendedor'"
                class="fs-item-menu-pedidos"
              >
                <v-icon class="mr-3">mdi-account-circle</v-icon>Selecionar Vendedor
              </v-list-item>
              <!-- <v-list-item @click="dialog = true; componente = 'selecionarfase'" class="fs-item-menu-pedidos">
                <v-icon class="mr-3">mdi-flag-outline</v-icon>
                Selecionar a Fase
              </v-list-item>-->
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <selecionarvendedor
            :fecharDialog="fecharDialog"
            v-if="componente === 'selecionarvendedor'"
          />
          <selecionarfase :fecharDialog="fecharDialog" v-if="componente === 'selecionarfase'" />
        </v-card>
      </v-dialog>

      <v-navigation-drawer
        :style="drawer ? 'margin-left: 9px !important' : 'margin-left: -30px !important'"
        class="fs-drawer-filter ma-2"
        mobile-break-point="0px"
        v-model="drawer"
        height="71vh"
        width="400px"
        hide-overlay
        temporary
        absolute
        bottom
      >
        <v-card flat class="pt-3 pl-2 pr-0">
          <div class="pb-1 mb-2 mr-2" style="border-bottom: 1px solid #EEEEEE">
            <h3 class="ml-2 mb-2">Filtros Específicos</h3>
          </div>
          <v-form autocomplete="off">
            <perfect-scrollbar style="height: 59vh">
              <div class="pt-1 pr-4">
                <v-row no-gutters>
                  <v-col md="12">
                    <v-row
                      class="mb-4 px-2 pt-1"
                      style="background-color: #F8F8F8; border: 1px solid #CCC; border-radius: 4px"
                      no-gutters
                    >
                      <v-col md="12">
                        <div class="mb-4 fs-div-filtros-checkbox">Filtro por Data</div>
                      </v-col>
                      <v-col md="5">
                        <v-menu
                          v-model="menuDataInicialFiltro"
                          :close-on-content-click="false"
                          :nudge-top="48"
                          :nudge-right="10"
                          transition="scale-transition"
                          max-width="290"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="mb-n5 mr-1"
                              :value="formatDataInicial"
                              append-outer-icon="mdi-calendar"
                              label="Data Inicial"
                              placeholder=" "
                              @click:clear="dataInicial = null"
                              v-on="on"
                              outlined
                              readonly
                              dense
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dataInicial"
                            @change="menuDataInicialFiltro = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col md="5">
                        <v-menu
                          v-model="menuDataFinalFiltro"
                          :close-on-content-click="false"
                          :nudge-top="48"
                          :nudge-right="10"
                          transition="scale-transition"
                          max-width="290"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="mb-n5 ml-1"
                              :value="formatDataFinal"
                              append-outer-icon="mdi-calendar"
                              label="Data Final"
                              placeholder=" "
                              @click:clear="dataFinal = null"
                              v-on="on"
                              outlined
                              readonly
                              dense
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="dataFinal" @change="menuDataFinalFiltro = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col md="2">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-switch
                              v-model="filtroData"
                              v-on="on"
                              class="mt-1 ml-5"
                              color="#2A2F50"
                              :value="true"
                              hide-details
                            ></v-switch>
                          </template>
                          <span
                            style="font-size: 11px"
                          >{{ filtroData ? 'FILTRO POR DATA ATIVADO' : 'FILTRO POR DATA DESATIVADO' }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="5">
                    <v-text-field
                      @keydown.enter="filtrar()"
                      id="textfield-id"
                      class="mb-n3 mr-1"
                      v-model="filtros.id"
                      spellcheck="false"
                      placeholder=" "
                      label="ID"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col md="7">
                    <v-text-field
                      @keydown.enter="filtrar()"
                      class="mb-n3 ml-1"
                      v-model="filtros.contato"
                      spellcheck="false"
                      placeholder=" "
                      label="Nome (Contato)"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col md="5">
                    <v-text-field
                      @keydown.enter="filtrar()"
                      class="mb-n3 mr-1"
                      v-model="filtros.cnpj"
                      spellcheck="false"
                      placeholder=" "
                      label="CNPJ"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col md="7">
                    <v-text-field
                      @keydown.enter="filtrar()"
                      class="mb-n3 ml-1"
                      v-model="filtros.nome"
                      spellcheck="false"
                      label="Razão Social"
                      placeholder=" "
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-select
                  class="mb-n3"
                  v-model="filtros.vendedor_id"
                  :items="vendedores"
                  spellcheck="false"
                  item-text="nome"
                  item-value="id"
                  label="Vendedor"
                  placeholder=" "
                  height="32px"
                  multiple
                  outlined
                  dense
                ></v-select>
                <v-select
                  class="mb-n3"
                  v-model="filtros.fase_id"
                  :items="fases"
                  spellcheck="false"
                  item-text="nome_fase"
                  item-value="id"
                  label="Fase"
                  placeholder=" "
                  height="32px"
                  multiple
                  outlined
                  dense
                ></v-select>
                <v-select
                  class="mb-n3"
                  v-model="filtros.confirmado"
                  :items="situacao"
                  spellcheck="false"
                  item-text="desc"
                  item-value="value"
                  label="Situação"
                  placeholder=" "
                  height="32px"
                  multiple
                  outlined
                  dense
                ></v-select>
                <v-select
                  class="mb-n3"
                  v-model="filtros.emotion"
                  :items="temperatura"
                  spellcheck="false"
                  item-text="desc"
                  item-value="value"
                  label="Temperatura (Emoticon)"
                  placeholder=" "
                  height="32px"
                  multiple
                  outlined
                  dense
                ></v-select>
                <div class="pl-3 pt-1 pb-1 mb-2" style="border: 1px solid #CCC; border-radius: 4px">
                  <div class="mr-2 mb-2 fs-div-filtros-checkbox">Comportamento</div>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_comportamento"
                        multiple
                        label="Cadastrou"
                        color="primary"
                        value="00"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_comportamento"
                        label="Adicionou no Carrinho"
                        color="primary"
                        value="02"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_comportamento"
                        label="Finalizou (Cliente)"
                        color="primary"
                        value="01"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_comportamento"
                        label="Cancelado pelo Cliente"
                        color="primary"
                        value="03"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-1 mb-4 mr-3" />
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_imprimiu"
                        label="Imprimiu"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_imprimiu"
                        label="Não Imprimiu"
                        color="primary"
                        value="N"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_email"
                        label="Enviou por Email"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_email"
                        label="Não Enviou por Email"
                        color="primary"
                        value="N"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_whatsapp"
                        label="Enviou por WhatsApp"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.feedback_whatsapp"
                        label="Não Enviou por WhatsApp"
                        color="primary"
                        value="N"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
                <div class="pl-3 pt-1 pb-1 mt-3" style="border: 1px solid #CCC; border-radius: 4px">
                  <div class="mr-2 mb-2 fs-div-filtros-checkbox">Solicitações de Contato</div>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.solicitou_contato_email"
                        label="Por Email"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.solicitou_contato_telefonico"
                        label="Por Telefone"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="naoSolicitouContato"
                        @change="setNaoSolicitouContato"
                        label="Não Solicitou"
                        color="primary"
                        value="N"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
                <v-row no-gutters>
                  <v-col md="6">
                    <div
                      class="pl-3 pt-1 pb-1 mt-3 mr-1"
                      style="border: 1px solid #CCC; border-radius: 4px"
                    >
                      <div class="mr-2 mb-2 fs-div-filtros-checkbox">Interações</div>
                      <v-row no-gutters>
                        <v-col md="12">
                          <v-checkbox
                            :ripple="false"
                            class="fs-checkbox-filtros"
                            v-model="filtros.interacoes"
                            label="Com Interações"
                            color="primary"
                            value="S"
                          ></v-checkbox>
                        </v-col>
                        <v-col>
                          <v-checkbox
                            :ripple="false"
                            class="fs-checkbox-filtros"
                            v-model="filtros.interacoes"
                            label="Sem Interações"
                            color="primary"
                            value="N"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col md="6">
                    <div
                      class="pl-3 pt-1 pb-1 mt-3 ml-1"
                      style="border: 1px solid #CCC; border-radius: 4px"
                    >
                      <div class="mr-2 mb-2 fs-div-filtros-checkbox">Alertas</div>
                      <v-row no-gutters>
                        <v-col md="12">
                          <v-checkbox
                            :ripple="false"
                            class="fs-checkbox-filtros"
                            v-model="filtros.alertas"
                            label="Não Vistos"
                            color="primary"
                            value="N"
                          ></v-checkbox>
                        </v-col>
                        <v-col>
                          <v-checkbox
                            :ripple="false"
                            class="fs-checkbox-filtros"
                            v-model="filtros.alertas"
                            label="Já Vistos"
                            color="primary"
                            value="S"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </perfect-scrollbar>
            <v-card-actions
              style="padding: 10px; position: fixed; right: 0px; bottom: 1px; width: 100%; border-top: 1px solid #CCC"
            >
              <v-btn small style="height: 27px" @click="resetFormFiltros">
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-filter-remove-outline</v-icon>Limpar Filtros
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="#2A2F50" @click="textoPesquisa = ''; filtrar()" dark small>
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-magnify</v-icon>Filtrar
              </v-btn>
              <v-btn color="warning" @click="drawer = false" dark small>
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>Fechar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-navigation-drawer>
    </v-card>

    <v-dialog width="400px" v-model="downloadExcel">
      <v-card>
        <v-card-title>Seu arquivo está pronto!</v-card-title>
        <v-card-text>Faça o download clicando no botão abaixo.</v-card-text>
        <v-divider class="ma-0" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#2A2F50"
            download="report.csv"
            :href="linkExcel"
            @click="downloadExcel = false"
            dark
            small
          >
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>Fazer Download
          </v-btn>
          <v-btn color="warning" @click="downloadExcel = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="500px" v-model="dialogAjuda">
      <v-card>
        <v-card-title>Ajuda</v-card-title>
        <v-card-subtitle class="mt-0">
          Legendas de
          <b>cores do grid</b>:
        </v-card-subtitle>
        <v-card-text>
          <span style="border: 1px solid #CCC" class="px-5 mr-2"></span> O cliente efetuou somente o cadastro.
          <br />
          <span style="border: 1px solid #CCC; background-color: #e3e9f7" class="px-5 mr-2"></span> O cliente gerou o orçamento, porém não confirmou o pedido.
          <br />
          <span style="border: 1px solid #CCC; background-color: #dcefd7" class="px-5 mr-2"></span> O cliente confirmou o pedido até o final.
          <br />
          <span style="border: 1px solid #CCC; background-color: #f7cdcd" class="px-5 mr-2"></span> O cliente cancelou o pedido.
        </v-card-text>
        <v-divider class="ma-0" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="dialogAjuda = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line
import { list, list2 } from '@/api/crud'
import { excel } from '@/api/report'
import moment from 'moment'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    selecionarvendedor: () => import('@/views/app/crm/listagemdepedidos/topbaropcoes/opcoes/selecionarvendedor'),
    selecionarfase: () => import('@/views/app/crm/listagemdepedidos/topbaropcoes/opcoes/selecionarfase')
  },
  data () {
    return {
      downloadExcel: false,
      filtroComposto: [],
      dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
      dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
      menuDataInicial: false,
      menuDataInicialFiltro: false,
      dialogAjuda: false,
      menuDataFinal: false,
      menuDataFinalFiltro: false,
      drawer: false,
      filtroData: true,
      dialog: false,
      componente: '',
      textoPesquisa: '',
      vendedores: [],
      linkExcel: null,
      excelLoader: false,
      naoSolicitouContato: null,
      situacao: [
        { desc: 'Confirmado', value: 'S' },
        { desc: 'Não Confirmado', value: 'N' }
      ],
      temperatura: [
        { desc: 'Quente', value: '3' },
        { desc: 'Indefinido (Morno)', value: '2' },
        { desc: 'Frio', value: '1' }
      ],
      filtros: {}
    }
  },
  computed: {
    ...mapState({
      filtroStatus: state => state.pedidos.filtroStatus,
      fases: state => state.ecommerce.fases
    }),
    formatDataInicial () {
      return this.dataInicial ? moment(this.dataInicial).format('DD/MM/YYYY') : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).format('DD/MM/YYYY') : ''
    }
  },
  watch: {
    // RESETA O FORM QUANDO O GRID NÃO ESTIVER SENDO FILTRADO
    filtroStatus: function () {
      if (!this.filtroStatus) this.resetFormFiltros()
    },
    '$route.params.filtro': {
      handler: function (filtro) {
        this.$store.state.pedidos.pedidosSelecionados = []
        this.limparFiltrosGrid()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    moment().locale('pt-br')
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar',
      setPedidos: 'pedidos/SETPEDIDOS',
      setFiltroStatus: 'pedidos/SETFILTROSTATUS',
      setFiltroAtual: 'pedidos/SETFILTROATUAL'
    }),
    ...mapActions({
      loadFases: 'ecommerce/loadFases',
      loadPedidos: 'pedidos/loadPedidos',
      loadPedidosFiltro: 'pedidos/loadPedidosFiltro'
    }),
    setNaoSolicitouContato () {
      if (this.naoSolicitouContato) {
        this.filtros.solicitou_contato_telefonico = 'N'
        this.filtros.solicitou_contato_email = 'N'
      }
    },
    async abrirDrawer () {
      document.getElementById('textfield-id').focus()
      this.drawer = !this.drawer
      this.vendedores = await list('/admin/vendedores')
      if (!this.fases.length) await this.loadFases()
    },
    limparFiltrosGrid () {
      this.linkExcel = null
      this.filtros = {}
      this.textoPesquisa = ''
      this.naoSolicitouContato = null
      // this.dataInicial = moment().startOf('month').format('YYYY-MM-DD')
      // this.dataFinal = moment().endOf('month').format('YYYY-MM-DD')
      // this.filtroData = false
      this.setFiltroAtual(null)
      this.filtrar()
      this.setFiltroStatus(false)
    },
    fecharDialog () {
      this.dialog = false
    },
    async pesquisar () {
      if (!this.textoPesquisa.length) {
        this.limparFiltrosGrid()
      } else {
        let origem = '1'
        if (this.$route.params.filtro === 'repeticao') {
          origem = '3'
        } else if (this.$route.params.filtro === 'campanha') {
          origem = '4'
        } else if (this.$route.params.filtro === 'recuperados') {
          origem = '6'
        }
        const pesquisa = [
          { field: 'id', value: parseInt(this.textoPesquisa) },
          { field: 'nome', value: this.textoPesquisa },
          { field: 'contato', value: this.textoPesquisa },
          { field: 'origem', value: origem }
        ]
        if (this.textoPesquisa.length >= 7) pesquisa.push({ field: 'cnpj', value: this.textoPesquisa })
        if (this.filtroData) {
          pesquisa.push({ field: 'dataInicial', value: this.dataInicial + ' 00:00:00' })
          pesquisa.push({ field: 'dataFinal', value: this.dataFinal + ' 23:59:59' })
        }
        await this.loadPedidosFiltro({ filtro: { tipo: 'pesquisa', query: this.querySerializePesquisa('pesquisa', pesquisa) }, pagination: null })
      }
    },
    async exportarExcel () {
      this.excelLoader = true
      setTimeout(async () => {
        this.montarFiltroComposto()
        const csvString = await excel(this.querySerialize('filtroComposto', this.filtroComposto))
        const universalBOM = '\uFEFF'
        this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
        this.excelLoader = false
        this.downloadExcel = true
      }, 700)
    },
    async filtrar () {
      this.drawer = false
      this.montarFiltroComposto()
      if (this.filtroComposto.length > 0) {
        try {
          const res = await this.loadPedidosFiltro({ filtro: { tipo: 'filtro', query: this.querySerialize('filtroComposto', this.filtroComposto) }, pagination: null })
          if (res.data.length) {
            if (this.filtroComposto.length > 1) this.setSnackbar({ msg: 'Os dados do grid foram atualizados!', color: 'green' })
          } else {
            this.setSnackbar({ msg: 'Nenhum registro foi encontrado!' })
          }
        } catch (error) {
          this.setSnackbar({ msg: `Houve um erro ao filtrar os registros: ${error}` })
        }
      }
    },
    montarFiltroComposto () {
      this.linkExcel = null
      this.filtroComposto = []
      if (this.filtros.id) this.filtros.id = parseInt(this.filtros.id) // A pesquisa por ID na API precisa ser por INT ao invés de String
      const keys = Object.keys(this.filtros)
      for (let i = 0; i < keys.length; i++) {
        if (!this.filtros[keys[i]] || this.filtros[keys[i]] === '') { continue }
        if (typeof this.filtros[keys[i]] === 'object' && !this.filtros[keys[i]].length) { continue }
        if (this.filtros[keys[i]]) {
          const type = this.filtros[keys[i]].length ? typeof this.filtros[keys[i]][0] : typeof this.filtros[keys[i]]
          this.filtroComposto.push({ field: keys[i], value: this.filtros[keys[i]], type })
        }
      }
      if (this.filtroData) {
        this.filtroComposto.push({ field: 'dataInicial', value: this.dataInicial + ' 00:00:00' })
        this.filtroComposto.push({ field: 'dataFinal', value: this.dataFinal + ' 23:59:59' })
      }
      let origem = '1'
      if (this.$route.params.filtro === 'repeticao') {
        origem = '3'
      } else if (this.$route.params.filtro === 'campanha') {
        origem = '4'
      } else if (this.$route.params.filtro === 'recuperados') {
        origem = '6'
      }
      this.filtroComposto.push({ field: 'origem', value: origem, type: 'string' })
    },
    async resetFormFiltros () {
      this.filtros = {}
    },
    querySerialize (nome, filtroComposto) {
      let query = ''
      for (let i = 0; i < filtroComposto.length; i++) {
        if (i === 0) query = query + nome
        query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        if (i < filtroComposto.length - 1) query = query + `&${nome}`
      }
      query = query.replace(/%2C/g, ',')
      return query
    },
    querySerializePesquisa (nome, filtroComposto) {
      let query = ''
      for (let i = 0; i < filtroComposto.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style>
.v-date-picker-table {
  height: 255px !important;
}
.fs-btn-icons-topbar {
  border: 1px solid rgb(209, 209, 209);
}
.fs-btn-filtro-ativo {
  background-color: rgb(245, 60, 47);
}
.fs-drawer-filter {
  padding: 5px;
  border-top-left-radius: 17px;
  border-bottom-right-radius: 0px !important;
  z-index: 1 !important;
}
.fs-menu-pedidos {
  width: 200px !important;
  padding-bottom: 13px;
  border: 1px solid #ccc !important;
  background-color: rgb(245, 245, 245) !important;
}
.fs-item-menu-pedidos {
  min-height: 25px;
  text-align: center;
  font-size: 12.5px;
  margin-top: 5px;
  padding-left: 18px;
  padding-right: 18px;
}
.fs-item-menu-pedidos:hover {
  background-color: rgba(224, 224, 224, 0.61);
  font-size: 12.5px;
  /* font-weight: 500; */
}
.fs-btn-enabled {
  transition: 0.8s;
  border: none;
  background-color: #2a2f50;
  color: white !important;
}
.fs-btn-disabled {
  transition: 0.8s;
  background-color: rgba(209, 209, 209, 0.349);
  border: 1px solid rgb(209, 209, 209);
  color: white !important;
}
.fs-boxshadow {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}
.fs-searchfield .v-input__icon--append .v-icon {
  margin-top: 2px;
  font-size: 20px !important;
}
.fs-searchfield .v-input__icon--append .v-icon:hover {
  color: black;
}
.fs-div-filtros-checkbox {
  text-align: center;
  font-weight: 300;
  font-size: 11.5px;
  color: gray;
}
.fs-checkbox-filtros {
  /* border: 1px solid red; */
  padding-top: 0px !important;
  margin-left: -5px !important;
  margin-top: -5px !important;
  height: 30px !important;
}
</style>
